import { render, staticRenderFns } from "./Onwumah.vue?vue&type=template&id=9c58cbf0&scoped=true&"
import script from "./Onwumah.vue?vue&type=script&lang=js&"
export * from "./Onwumah.vue?vue&type=script&lang=js&"
import style0 from "./Onwumah.vue?vue&type=style&index=0&id=9c58cbf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c58cbf0",
  null
  
)

export default component.exports